module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "height=100%"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-1"
  }, [_c('v-icon', {
    staticClass: "mx-2",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n    Get started with AppointmentGuru\n    "), _c('v-spacer'), _vm._v(" "), (!_vm.showScan) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showScan = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("qr_code")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "hidden-sm-and-up justify-center"
  }, [_c('center', [_vm._v("\n      Looks like you're on a mobile device.\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("install")
      }
    }
  }, [_vm._v("Install AppointmentGuru on your device")])], 1)], 1), _vm._v(" "), _c('center', [(_vm.showScan) ? _c('v-card', {
    staticClass: "grey lighten-4 pb-3 hidden-xs-only my-4",
    attrs: {
      "width": "300"
    }
  }, [_c('v-card-text', {
    staticClass: "hidden-xs-only justify-center"
  }, [_c('center', [_c('v-img', {
    attrs: {
      "width": "100",
      "height": "100",
      "src": "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://app.appointmentguru.co/#/get-started"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "absolute": "",
      "fab": "",
      "small": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showScan = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "caption mt-2"
  }, [_c('b', [_vm._v("Tip:")]), _vm._v(" Scan this code to open the app on your mobile device.\n      Then you can view the instructions and videos on your computer while you complete the tasks on your phone (or vice versa)\n      ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "top": "",
      "left": "",
      "nudge-left": "",
      "activator": "#main-speed-dail",
      "offset-x": true
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 elevation-10 mr-3 mb-2 blue white--text overline",
    attrs: {
      "dense": "",
      "transition": "slide-x-transition"
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Start here")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "nudge-bottom": "",
      "activator": "#global-guides-btn",
      "offset-y": true
    },
    model: {
      value: (_vm.showFindGuides),
      callback: function($$v) {
        _vm.showFindGuides = $$v
      },
      expression: "showFindGuides"
    }
  }, [_c('v-card', {
    staticClass: "mt-3 mr-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n        Guides are here\n      ")], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        You can always return to this guide using the\n        "), _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("tour")]), _vm._v("\n        icon in the toolbar above\n      ")], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showFindGuides = false
      }
    }
  }, [_vm._v("Got it")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading justify-center"
  }, [_c('blockquote', {
    staticClass: "blockquote pl-0"
  }, [_vm._v("\n    This guide will walk you through the basics of using AppointmentGuru.\n    You will learn how to: create an appointment, add medical aid codes to the appointment, create an invoice and share the invoice with your clients\n    ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-timeline-item', {
      key: item.id,
      staticClass: "pb-0",
      class: {
        'accent lighten-2': _vm.step === index
      },
      attrs: {
        "color": "success",
        "icon": "plus"
      },
      on: {
        "click": function($event) {
          return _vm.setStep(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('v-avatar', {
            staticClass: "white--text",
            attrs: {
              "size": "10"
            }
          }, [(item.done === true) ? _c('v-icon', {
            attrs: {
              "color": "white"
            }
          }, [_vm._v("check")]) : _c('span', [_vm._v(_vm._s(index + 1))])], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-layout', {
      staticClass: "pt-2"
    }, [_c('v-flex', [_c('strong', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-caption",
      domProps: {
        "textContent": _vm._s(item.description)
      }
    })]), _vm._v(" "), _c('v-flex', {
      staticClass: "justify-right"
    }, [_c('v-btn', {
      staticClass: "right",
      attrs: {
        "disabled": item.disabled === true,
        "flat": item.done,
        "color": "success"
      },
      on: {
        "click": function($event) {
          return _vm.setStep(item)
        }
      }
    }, [_vm._v("Go")])], 1)], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pl-0"
  }, [_c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "to": "/",
      "flat": ""
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "grey lighten-4 pl-3 caption"
  }, [_vm._v("\n    AppointmentGuru > Guides > Getting started\n  ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.showInstructions),
      callback: function($$v) {
        _vm.showInstructions = $$v
      },
      expression: "showInstructions"
    }
  }, [(_vm.selectedItem) ? _c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedItem.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showInstructions = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote pa-0",
    domProps: {
      "textContent": _vm._s(_vm.selectedItem.description)
    }
  })]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.selectedItem.instructions && _vm.selectedItem.instructions.video) ? _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "62.5%",
      "height": "0"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.selectedItem.instructions.video,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": "",
      "lazy": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedItem.instructions && _vm.selectedItem.instructions.steps) ? _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                Instructions\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ol', _vm._l((_vm.selectedItem.instructions.steps), function(item) {
    return _c('li', {
      key: item.title
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.items) ? _c('ol', _vm._l((item.items), function(sub) {
      return _c('li', {
        key: sub,
        domProps: {
          "textContent": _vm._s(sub)
        }
      })
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), ((_vm.selectedItem.id === "add_codes" || _vm.selectedItem.id === "create_invoice") && _vm.lastAppointment) ? _c('v-list', {
    staticClass: "elevation-5 mb-3 pa-0",
    attrs: {
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "grey lighten-4 overline my-0 py-0"
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.lastAppointment
    }
  }, [_c('v-list-tile-action', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('appointment-action-menu', {
    attrs: {
      "appointment": _vm.lastAppointment
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedItem.id === "send_invoice") ? _c('v-card', [(_vm.invoices.length === 0) ? _c('v-btn', {
    on: {
      "click": _vm.loadInvoices
    }
  }, [_vm._v("Load invoices")]) : _vm._e(), _vm._v(" "), (_vm.lastInvoice) ? _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('invoice-list', _vm._g({
    attrs: {
      "invoices": [_vm.lastInvoice],
      "actions": _vm.invoiceActions
    }
  }, _vm.invoiceEvents))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedItem.instructions && _vm.selectedItem.instructions.results) ? [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                  By the end of this tutorial you will know:\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ol', _vm._l((_vm.selectedItem.instructions.results), function(result) {
    return _c('li', {
      key: result,
      domProps: {
        "textContent": _vm._s(result)
      }
    })
  }), 0)])] : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showInstructions = false
      }
    }
  }, [_vm._v("Got it!")])], 1)], 2)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26294ca9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/guides/GetStarted.vue
// module id = 1362
// module chunks = 9